export type Fiat = 'EUR' | 'USD' | 'GBP' | 'CHF' | 'AUD' | 'CAD' | 'TRY' | 'NZD' | 'HKD' | 'SGD' | 'JPY';

type Rates = Record<Fiat, number>;

export type CurrencyInfo = {
  currency: string;
  currencyName: string;
  rates: Rates;
};

export type ApiResponse = CurrencyInfo[];

export type RatesMap = {
  [key: string]: {
    rates: Rates;
  };
};

export function transformToRatesMap(apiResponse: ApiResponse | null) {
  const result: RatesMap = {};

  if (!apiResponse) {
    return result;
  }

  apiResponse.forEach((currencyInfo) => {
    const { currency, rates } = currencyInfo;
    result[currency] = { rates };
  });

  return result;
}

export const mockApiResponse: ApiResponse = [
  {
    currency: 'BTC',
    currencyName: 'Bitcoin',
    rates: {
      EUR: 46115.86,
      USD: 51408.7,
      GBP: 40333.2,
      CHF: 43561.67,
      AUD: 76534.06,
      CAD: 68653.23,
      TRY: 1538466.3,
      NZD: 82260.49,
      HKD: 401501.89,
      SGD: 68285.14,
      JPY: 7385012.88,
    },
  },
  {
    currency: 'ETH',
    currencyName: 'Ethereum',
    rates: {
      EUR: 2279.97,
      USD: 2541.65,
      GBP: 1994.08,
      CHF: 2153.69,
      AUD: 3783.85,
      CAD: 3394.22,
      TRY: 76061.8,
      NZD: 4066.96,
      HKD: 19850.26,
      SGD: 3376.02,
      JPY: 365115.12,
    },
  },
  {
    currency: 'USDT',
    currencyName: 'Tether USD',
    rates: {
      EUR: 0.99,
      USD: 1.1,
      GBP: 0.87,
      CHF: 0.94,
      AUD: 1.64,
      CAD: 1.47,
      TRY: 32.91,
      NZD: 1.76,
      HKD: 8.59,
      SGD: 1.47,
      JPY: 157.96,
    },
  },
  {
    currency: 'USDC',
    currencyName: 'USD coin',
    rates: {
      EUR: 0.99,
      USD: 1.1,
      GBP: 0.87,
      CHF: 0.94,
      AUD: 1.64,
      CAD: 1.47,
      TRY: 32.92,
      NZD: 1.76,
      HKD: 8.59,
      SGD: 1.47,
      JPY: 157.99,
    },
  },
];
